import '../Navbar/Navbar.css'
import {Link } from 'react-router-dom'

const Navtab2 = () => {
return<>
<li className="nav-item dropdown custom-margin1">
              <a className="nav-link dropdown-toggle" href=" " role="button" data-bs-toggle="dropdown" aria-expanded="false" style = {{color: 'white'}}>
                Projects
              </a>
              <ul className="dropdown-menu">
              <li><a className="dropdown-item" href=" "><Link to='/irrigation'><button className='btn'> Irrigation Automation</button></Link></a></li>
                <li> <hr className="dropdown-divider"/></li>
                <li><a className="dropdown-item" href=" "><Link to='/honey'><button className='btn'>Honey Traceability</button></Link></a></li>
              
              </ul>
            </li>
            </>
};
export default Navtab2;